import { z } from 'zod';
import { ActivitySourceSchema } from '../activity/activities.schemas';
import { ActorSchema } from '../common/actor.schema';

export const ViewingInvitationSentPayloadSchema = z.object({
  invitationId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  prospectId: z.uuid(),
  appointmentId: z.uuid(),
  sequence: z.number().int().nonnegative(),
  actor: ActorSchema,
  origin: ActivitySourceSchema.default('APP'),
  occurredAt: z.iso.datetime(),
});

export type ViewingInvitationSentPayload = z.infer<typeof ViewingInvitationSentPayloadSchema>;

const ViewingScheduleSnapshotSchema = z.object({
  startsAt: z.iso.datetime(),
  endsAt: z.iso.datetime(),
  isAllDay: z.boolean(),
});

export const ViewingInvitationRescheduledPayloadSchema = z.object({
  invitationId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  prospectId: z.uuid(),
  appointmentId: z.uuid(),
  sequence: z.number().int().positive(),
  previous: ViewingScheduleSnapshotSchema,
  occurredAt: z.iso.datetime(),
});

export type ViewingInvitationRescheduledPayload = z.infer<typeof ViewingInvitationRescheduledPayloadSchema>;

export const ViewingInvitationCancelledPayloadSchema = z.object({
  invitationId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  prospectId: z.uuid(),
  appointmentId: z.uuid(),
  sequence: z.number().int().positive(),
  // The prospect_history row the invitation's forward move wrote; null when it moved nothing.
  phaseMoveHistoryId: z.uuid().nullable(),
  occurredAt: z.iso.datetime(),
});

export type ViewingInvitationCancelledPayload = z.infer<typeof ViewingInvitationCancelledPayloadSchema>;

export const ViewingReminderDuePayloadSchema = z.object({
  invitationId: z.uuid(),
  workspaceId: z.uuid(),
  // The notified start this timer was set for; a timer whose start is no longer the invitation's is stale.
  startsAt: z.iso.datetime(),
});

export type ViewingReminderDuePayload = z.infer<typeof ViewingReminderDuePayloadSchema>;

export const ViewingInvitationRemindedPayloadSchema = z.object({
  invitationId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  prospectId: z.uuid(),
  appointmentId: z.uuid(),
  startDay: z.iso.date(),
  occurredAt: z.iso.datetime(),
});

export type ViewingInvitationRemindedPayload = z.infer<typeof ViewingInvitationRemindedPayloadSchema>;
